import PlatformApiClient from './platform-api-client';
import Config            from './config';

export default class Announcement {

  constructor(properties) {
    this.label = properties.label;
    this.link = properties.link;
    this.external = properties.external;
  }

  static load(clientId) {
    const apiClient = new PlatformApiClient(clientId);

    return apiClient.findAnnouncements({
      device: PlatformApiClient.DEVICE_ID.SP,
    }).then((result) => {
      return result.notices.map((announcement) => {
        const genericUrl = new URL(`/announcement/${announcement.id}`, Config.SERVICE_LINK.ATCOSME.SP.URL);
        const linkUrl    = announcement.link == 0 ? genericUrl.href : announcement.link_url;
        const date       = new Date(announcement.opened_at);
        const title      = `${announcement.title}(${date.getMonth() + 1}/${date.getDate()})`;

        return new this({
          label   : title,
          link    : linkUrl,
          external: announcement.link_type == 1,
        });
      });
    });
  }
}
